// Meta CAPI client — forwards events to server, gated by GDPR consent.
// Runs IN PARALLEL with fbq() using the same event_id → Meta dedupes automatically.
import { supabase } from "@/integrations/supabase/client";

function hasAdConsent(): boolean {
  try {
    const c = (window as any).__consent || {};
    if (c.ad_storage === "granted") return true;
    // Same keys the GDPR banner writes (src/utils/gdprConsent.ts), current banner version only.
    if (localStorage.getItem("gdpr_banner_version") !== "v2.3") return false;
    if (localStorage.getItem("gdpr_consent") === null) return false;
    return localStorage.getItem("gdpr_marketing_consent") === "true";
  } catch {
    return false;
  }
}

function readCookie(name: string): string | undefined {
  const match = document.cookie.match(new RegExp("(^|; )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : undefined;
}

export interface CapiEventInput {
  event_name: string;
  event_id: string;
  email?: string;
  phone?: string;
  user_id?: string;
  custom_data?: Record<string, unknown>;
}

export async function sendCapiEvent(input: CapiEventInput): Promise<void> {
  const consent_granted = hasAdConsent();
  // Still log the event server-side (as blocked) for GDPR audit — but never send to Meta.
  try {
    await supabase.functions.invoke("meta-capi", {
      body: {
        event_name: input.event_name,
        event_id: input.event_id,
        event_source_url: window.location.href,
        consent_granted,
        user_data: consent_granted
          ? {
              email: input.email,
              phone: input.phone,
              external_id: input.user_id,
              fbp: readCookie("_fbp"),
              fbc: readCookie("_fbc"),
            }
          : undefined,
        custom_data: input.custom_data,
      },
    });
  } catch {
    // fire-and-forget; never break UX if CAPI is down
  }
}
